module.exports = __webpack_public_path__ + "img/107049.14eca75f.png";